import { render, staticRenderFns } from "./FlashExpress.vue?vue&type=template&id=1ae94ad1&scoped=true"
import script from "./FlashExpress.vue?vue&type=script&lang=js"
export * from "./FlashExpress.vue?vue&type=script&lang=js"
import style0 from "./FlashExpress.vue?vue&type=style&index=0&id=1ae94ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae94ad1",
  null
  
)

export default component.exports